/**
 * SITE HEADER
 *
 * @returns {Promise<void>}
 */
import {getAllMenuCookies} from '@/js/funnel/_mixins/menu-cookie';
const siteHeader = async () => {
    const [
        {default: Vue},
        {VBToggle},
        {NavPlugin},
        {BNavItemDropdown},
        {AjaxMixin},
        {default: Feather},
    ] = await Promise.all([
        import(/* webpackChunkName: "vue" */ 'vue'),
        import(/* webpackChunkName: "bs-toggle" */ 'bootstrap-vue'),
        import(/* webpackChunkName: "bs-nav" */ 'bootstrap-vue'),
        import(/* webpackChunkName: "bs-nav-item-dropdown" */ 'bootstrap-vue'),
        import(/* webpackChunkName: "global-mixins-ajax" */ '@mymyMixins/ajax'),
        import(/* webpackChunkName: "feather-icons" */ 'vue-feather/src/feather'),
    ]);

    Vue.use(VBToggle)
    Vue.use(NavPlugin)

    // Create our vue instance
    const vm = new Vue({
        name: 'SiteHeader',
        el: '#site-header',
        delimiters: ['[[', ']]'],
        mixins: [AjaxMixin],
        directives: {
            'b-toggle': VBToggle,
        },
        components: {
            'feather-icon': Feather,
        },
        data: {
            cartsNav: [],
            mainNavActive: false,
            mainNavActiveItem: null,
        },
        async mounted() {
            // fetch data about the currently logged-in user and show login/logout buttons
            const response = await this.makePostRequest('mymy/settings/site-header-data', {
                menuCookies: this.getMenuCookies(),
            });

            // load up Vue's local data with the response data
            for (const key in response.data) {
                this[key] = response.data[key];
            }
        },
        created() {
            window.addEventListener("resize", this.myEventHandler);
        },
        destroyed() {
            window.removeEventListener("resize", this.myEventHandler);
        },
        methods: {
            myEventHandler(e) {
                if(e.target.innerWidth >= 992) {
                    this.mainNavActive = false;
                    this.mainNavActiveItem = null;
                }
            },

            toggleMainNav() {
                this.mainNavActive = !this.mainNavActive;
            },

            navItemClicked(navItemId) {
                if(!this.mainNavActive) {
                    return;
                }
                if(this.mainNavActiveItem == navItemId) {
                    return;
                }

                event.preventDefault();
                this.mainNavActiveItem = navItemId;
            },

            /**
             * Get all the "menu cookies" from the customer's browser that have cart numbers and
             * match the current site's country ISO code.
             *
             * @return {*[]}
             */
            getMenuCookies() {
                let menuCookies = [];
                const allMenuCookies = getAllMenuCookies();
                for (const cookieName in allMenuCookies) {
                    const cookieValue = allMenuCookies[cookieName];
                    const cartNumber = cookieValue.n ?? null;
                    if (typeof cartNumber === 'string' && cartNumber) {
                        const menu = cookieName.split('_');
                        menuCookies.push({
                            country: menu[2],
                            id: parseInt(menu[1]),
                            number: cartNumber,
                        });
                    }
                }

                return menuCookies;
            },
        },
    });

    return vm;
};

// Execute async function
siteHeader().then( (vm) => {
});